<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button defaultHref="about" data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">Version</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list class="ion-text-wrap">
        <ion-item-divider color="tertiary">
            Interesting Facts
        </ion-item-divider>

        <ion-item id="version">
            <ion-label class="ion-text-wrap">
                <span class="line1">Domain</span><br />
                <span class="line2">{{vm.domain}}</span>
            </ion-label>
        </ion-item>

        <ion-item id="version">
            <ion-label class="ion-text-wrap">
                <span class="line1">Version</span><br />
                <span class="line2" data-test="version">{{vm.version}}</span>
            </ion-label>
        </ion-item>

        <ion-item id="releaseDate">
            <ion-label class="ion-text-wrap" data-test="releaseDate">
                <span class="line1">Release Date</span><br />
                <span class="line2">{{vm.releaseDate}}</span>
            </ion-label>
        </ion-item>

        <ion-item id="companyName">
            <ion-label class="ion-text-wrap">
                <span class="line1">Company Name</span><br />
                <span class="line2">ShuttleNomix</span>
            </ion-label>
        </ion-item>

        <ion-item id="productName">
            <ion-label class="ion-text-wrap">
                <span class="line1">Product Name</span><br />
                <span class="line2">ShuttleNomix</span>
            </ion-label>
        </ion-item>

        <ion-item id="meaning">
            <ion-label class="ion-text-wrap">
                <span class="line1">Meaning of ShuttleNomix</span><br />
                <span class="line2">ShuttleNomix is the marriage of the two words 'Shuttle' and 'Economics'</span>
            </ion-label>
        </ion-item>

    </ion-list>
</ion-content>